export const connectMyDeviceStatusSelector = (state: RootState) => state.connectMyDevice.status;
